// src/router/relatorios.js

// Quem abre cada relatório (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa. `report_access_all` é a super-role de relatórios.
// Previsão por cliente e Controle de lavação estão fora do menu e seguem sem guarda até a decisão do time.
const ROLES_PREVISAO_FATURAMENTO = [
    'report_access_all',
    'gerente_relacionamento_cliente',
    'relacionamento_cliente',
    'coordenador_operacional',
    'prana_vendedores',
    'relatorio_previsao_faturamento'
]
const ROLES_DISTRIBUICAO_PROCESSOS = ['report_access_all', 'coordenador_operacional', 'diretoria']
const ROLES_PESSOA_CONTA_BANCARIA = ['report_access_all', 'coordenador_operacional', 'financeiro']
const ROLES_PROCESSOS_ESTATISTICAS = [
    'report_access_all',
    'coordenador_operacional',
    'colaborador_prana',
    'colaborador_satya',
    'agente_carga',
    'cliente'
]


const relatoriosBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    }
]
export default [
    {
        path: '/relatorios/prev-faturamento-mensal-por-cliente',
        name: 'RelatorioPrevisaoFaturamentoMensalPorCliente',
        component: () => import('@/views/Relatorios/PrevisaoFaturamentoPorCliente/PrevisaoFaturamentoPorCliente.vue'),
        meta: {
            title: 'Previsão Faturamento Mensal por Cliente',
            breadcrumb: [
                ...relatoriosBreadCrumb,
                {
                    label: 'Novo Relatorio',
                    to: 'RelatorioNovo'
                }
            ]
        }
    },
    {
      path: '/relatorios/prev-faturamento-mensal',
      name: 'RelatorioPrevisaoFaturamentoMensalNovo',
      component: () => import('@/views/Relatorios/PrevisaoFaturamentoNovo/PrevisaoFaturamentoSemanal.vue'),
      meta: {
        roles: ROLES_PREVISAO_FATURAMENTO,
        title: 'Previsão Faturamento Semanal',
        breadcrumb: [
          ...relatoriosBreadCrumb,
          {
            label: 'Novo Relatorio',
            to: 'RelatorioNovo'
          }
        ]
      }
    },
    // Relatório de previsão de faturamento mensal antigo
    // {
    //     path: '/relatorios/prev-faturamento-mensal',
    //     name: 'RelatorioPrevisaoFaturamentoMensal',
    //     component: PrevisaoFaturamentoMensal,
    //     meta: {
    //         title: 'Previsão Faturamento Mensal',
    //         breadcrumb: [
    //             ...relatoriosBreadCrumb,
    //             {
    //                 label: 'Novo Relatorio',
    //                 to: 'RelatorioNovo'
    //             }
    //         ]
    //     }
    // },
    {
        path: '/relatorios/controle-container-lavacao',
        name: 'RelatorioControleContainerLavacao',
        component: () => import('@/views/Relatorios/ControleContainerLavacao/ControleContainerLavacao.vue'),
        meta: {
            title: 'Controle Container Lavacação',
            requiresAuth: false,
            breadcrumb: [
                ...relatoriosBreadCrumb,
                {
                    label: 'Novo Relatorio',
                    to: 'RelatorioNovo'
                }
            ]
        }
    },
    {
        path: '/relatorios/v2/distribuicao-processos-classificacao-responsavel',
        name: 'RelatorioDistribuicaoProcessosClassificacaoResponsavelV2',
        component: () => import('@/views/Relatorios/DistribuicaoProcessos/ProcessosDistribuicao.vue'),
        meta: {
            roles: ROLES_DISTRIBUICAO_PROCESSOS,
            title: 'Distribuição de Processos por Classificacao e Responsável',
            breadcrumb: [
                ...relatoriosBreadCrumb,
                {
                    label: 'Novo Relatorio',
                    to: 'RelatorioNovo'
                }
            ]
        }
    },
    {
        path: '/relatorios/pessoa-conta-bancaria',
        name: 'RelatorioPessoaContaBancaria',
        component: () => import('@/views/Relatorios/PessoaContaBancaria/PessoaContaBancariaListPage.vue'),
        meta: {
            roles: ROLES_PESSOA_CONTA_BANCARIA,
            title: 'Distribuição de Processos por Classificacao e Responsável',
            breadcrumb: [
                ...relatoriosBreadCrumb
            ]
        }
    },
    {
        path: '/relatorios/processos-estatisticas',
        name: 'RelatorioProcessosEstatisticas',
        component: () => import('@/views/Relatorios/ProcessosEstatisticas/ProcessosEstatisticas.vue'),
        meta: {
            roles: ROLES_PROCESSOS_ESTATISTICAS,
            title: 'Estatísticas',
            breadcrumb: [
                ...relatoriosBreadCrumb
            ]
        }
    }
];
